export const AWAITING_QUOTE_STATUS = 1;
export const QUOTE_ISSUED_STATUS = 2;
export const AWAITING_PAYMENT_STATUS = 3;
export const AWAITING_CONFIRMATION_STATUS = 4;
export const PAYMENT_FAILED = 5;
export const AWAITING_SHIPPING_STATUS = 6;
export const DELIVERED_PAID_STATUS = 7;
export const CANCELED_STATUS = 8;
export const IN_DELEVERY_STATUS = 12;
export const DELEVERED_STATUS = 13;
export const READY_TO_SHIP_STATUS = 14;
export const PENDING_RECEIPT_STATUS = 16;

export const SIZES = [
  { name: "S" },
  { name: "M" },
  { name: "L" },
  { name: "XL" },
  { name: "XXL" },
  { name: "standard" },
  { name: "36" },
  { name: "37" },
  { name: "38" },
  { name: "39" },
  { name: "40" },
  { name: "41" },
  { name: "42" },
];

export let COUNTRIES = [
  { name: "Afghanistan" },
  { name: "Albanie" },
  { name: "Algérie" },
  { name: "Andorre" },
  { name: "Angola" },
  { name: "Antigua-et-Barbuda" },
  { name: "Argentine" },
  { name: "Arménie" },
  { name: "Australie" },
  { name: "Autriche" },
  { name: "Azerbaïdjan" },
  { name: "Bahamas" },
  { name: "Bahreïn" },
  { name: "Bangladesh" },
  { name: "Barbade" },
  { name: "Bélarus" },
  { name: "Belgique" },
  { name: "Belize" },
  { name: "Bénin" },
  { name: "Bhoutan" },
  { name: "Bolivie" },
  { name: "Bosnie-Herzégovine" },
  { name: "Botswana" },
  { name: "Brésil" },
  { name: "Brunéi" },
  { name: "Bulgarie" },
  { name: "Burkina Faso" },
  { name: "Burundi" },
  { name: "Cabo Verde" },
  { name: "Cambodge" },
  { name: "Cameroun" },
  { name: "Canada" },
  { name: "République centrafricaine" },
  { name: "Tchad" },
  { name: "Chili" },
  { name: "Chine" },
  { name: "Colombie" },
  { name: "Comores" },
  { name: "Congo" },
  { name: "Costa Rica" },
  { name: "Croatie" },
  { name: "Cuba" },
  { name: "Chypre" },
  { name: "Tchéquie" },
  { name: "Danemark" },
  { name: "Djibouti" },
  { name: "Dominique" },
  { name: "République dominicaine" },
  { name: "Équateur" },
  { name: "Égypte" },
  { name: "Salvador" },
  { name: "Guinée équatoriale" },
  { name: "Érythrée" },
  { name: "Estonie" },
  { name: "Eswatini" },
  { name: "Éthiopie" },
  { name: "Fidji" },
  { name: "Finlande" },
  { name: "France" },
  { name: "Gabon" },
  { name: "Gambie" },
  { name: "Géorgie" },
  { name: "Allemagne" },
  { name: "Ghana" },
  { name: "Grèce" },
  { name: "Grenade" },
  { name: "Guatemala" },
  { name: "Guinée" },
  { name: "Guinée-Bissau" },
  { name: "Guyana" },
  { name: "Haïti" },
  { name: "Honduras" },
  { name: "Hongrie" },
  { name: "Islande" },
  { name: "Inde" },
  { name: "Indonésie" },
  { name: "Iran" },
  { name: "Irak" },
  { name: "Irlande" },
  { name: "Israël" },
  { name: "Italie" },
  { name: "Jamaïque" },
  { name: "Japon" },
  { name: "Jordanie" },
  { name: "Kazakhstan" },
  { name: "Kenya" },
  { name: "Kiribati" },
  { name: "Corée du Nord" },
  { name: "Corée du Sud" },
  { name: "Kosovo" },
  { name: "Koweït" },
  { name: "Kirghizistan" },
  { name: "Laos" },
  { name: "Lettonie" },
  { name: "Liban" },
  { name: "Lesotho" },
  { name: "Libéria" },
  { name: "Libye" },
  { name: "Liechtenstein" },
  { name: "Lituanie" },
  { name: "Luxembourg" },
  { name: "Madagascar" },
  { name: "Malawi" },
  { name: "Malaisie" },
  { name: "Maldives" },
  { name: "Mali" },
  { name: "Malte" },
  { name: "Îles Marshall" },
  { name: "Mauritanie" },
  { name: "Maurice" },
  { name: "Mexique" },
  { name: "Micronésie" },
  { name: "Moldavie" },
  { name: "Monaco" },
  { name: "Mongolie" },
  { name: "Monténégro" },
  { name: "Maroc" },
  { name: "Mozambique" },
  { name: "Myanmar" },
  { name: "Namibie" },
  { name: "Nauru" },
  { name: "Népal" },
  { name: "Pays-Bas" },
  { name: "Nouvelle-Zélande" },
  { name: "Nicaragua" },
  { name: "Niger" },
  { name: "Nigeria" },
  { name: "Macédoine du Nord" },
  { name: "Norvège" },
  { name: "Oman" },
  { name: "Pakistan" },
  { name: "Palaos" },
  { name: "Panama" },
  { name: "Papouasie-Nouvelle-Guinée" },
  { name: "Paraguay" },
  { name: "Pérou" },
  { name: "Philippines" },
  { name: "Pologne" },
  { name: "Portugal" },
  { name: "Qatar" },
  { name: "Roumanie" },
  { name: "Russie" },
  { name: "Rwanda" },
  { name: "Saint-Christophe-et-Niévès" },
  { name: "Sainte-Lucie" },
  { name: "Saint-Vincent-et-les Grenadines" },
  { name: "Samoa" },
  { name: "Saint-Marin" },
  { name: "Sao Tomé-et-Principe" },
  { name: "Arabie saoudite" },
  { name: "Sénégal" },
  { name: "Serbie" },
  { name: "Seychelles" },
  { name: "Sierra Leone" },
  { name: "Singapour" },
  { name: "Slovaquie" },
  { name: "Slovénie" },
  { name: "Îles Salomon" },
  { name: "Somalie" },
  { name: "Afrique du Sud" },
  { name: "Soudan du Sud" },
  { name: "Espagne" },
  { name: "Sri Lanka" },
  { name: "Soudan" },
  { name: "Suriname" },
  { name: "Suède" },
  { name: "Suisse" },
  { name: "Syrie" },
  { name: "Taïwan" },
  { name: "Tadjikistan" },
  { name: "Tanzanie" },
  { name: "Thaïlande" },
  { name: "Timor-Leste" },
  { name: "Togo" },
  { name: "Tonga" },
  { name: "Trinité-et-Tobago" },
  { name: "Tunisie" },
  { name: "Turquie" },
  { name: "Turkménistan" },
  { name: "Tuvalu" },
  { name: "Ouganda" },
  { name: "Ukraine" },
  { name: "Émirats arabes unis" },
  { name: "Royaume-Uni" },
  { name: "États-Unis" },
  { name: "Uruguay" },
  { name: "Ouzbékistan" },
  { name: "Vanuatu" },
  { name: "Cité du Vatican" },
  { name: "Venezuela" },
  { name: "Vietnam" },
  { name: "Yémen" },
  { name: "Zambie" },
  { name: "Zimbabwe" },
];
export let PAYS = [
  { id: 1, name: { en: "Afghanistan", fr: "Afghanistan", ar: "أفغانستان" } },
  { id: 2, name: { en: "Albania", fr: "Albanie", ar: "ألبانيا" } },
  { id: 3, name: { en: "Algeria", fr: "Algérie", ar: "الجزائر" } },
  { id: 4, name: { en: "Andorra", fr: "Andorre", ar: "أندورا" } },
  { id: 5, name: { en: "Angola", fr: "Angola", ar: "أنغولا" } },
  {
    id: 6,
    name: {
      en: "Antigua and Barbuda",
      fr: "Antigua-et-Barbuda",
      ar: "أنتيغوا وبربودا",
    },
  },
  { id: 7, name: { en: "Argentina", fr: "Argentine", ar: "الأرجنتين" } },
  { id: 8, name: { en: "Armenia", fr: "Arménie", ar: "أرمينيا" } },
  { id: 9, name: { en: "Australia", fr: "Australie", ar: "أستراليا" } },
  { id: 10, name: { en: "Austria", fr: "Autriche", ar: "النمسا" } },
  { id: 11, name: { en: "Azerbaijan", fr: "Azerbaïdjan", ar: "أذربيجان" } },
  { id: 12, name: { en: "Bahamas", fr: "Bahamas", ar: "البهاما" } },
  { id: 13, name: { en: "Bahrain", fr: "Bahreïn", ar: "البحرين" } },
  { id: 14, name: { en: "Bangladesh", fr: "Bangladesh", ar: "بنغلاديش" } },
  { id: 15, name: { en: "Barbados", fr: "Barbade", ar: "بربادوس" } },
  { id: 16, name: { en: "Belarus", fr: "Bélarus", ar: "بيلاروس" } },
  { id: 17, name: { en: "Belgium", fr: "Belgique", ar: "بلجيكا" } },
  { id: 18, name: { en: "Belize", fr: "Belize", ar: "بليز" } },
  { id: 19, name: { en: "Benin", fr: "Bénin", ar: "بنين" } },
  { id: 20, name: { en: "Bhutan", fr: "Bhoutan", ar: "بوتان" } },
  { id: 21, name: { en: "Bolivia", fr: "Bolivie", ar: "بوليفيا" } },
  {
    id: 22,
    name: {
      en: "Bosnia and Herzegovina",
      fr: "Bosnie-Herzégovine",
      ar: "البوسنة والهرسك",
    },
  },
  { id: 23, name: { en: "Botswana", fr: "Botswana", ar: "بوتسوانا" } },
  { id: 24, name: { en: "Brazil", fr: "Brésil", ar: "البرازيل" } },
  { id: 25, name: { en: "Brunei", fr: "Brunéi", ar: "بروناي" } },
  { id: 26, name: { en: "Bulgaria", fr: "Bulgarie", ar: "بلغاريا" } },
  {
    id: 27,
    name: { en: "Burkina Faso", fr: "Burkina Faso", ar: "بوركينا فاسو" },
  },
  { id: 28, name: { en: "Burundi", fr: "Burundi", ar: "بوروندي" } },
  { id: 29, name: { en: "Cabo Verde", fr: "Cabo Verde", ar: "الرأس الأخضر" } },
  { id: 30, name: { en: "Cambodia", fr: "Cambodge", ar: "كمبوديا" } },
  { id: 31, name: { en: "Cameroon", fr: "Cameroun", ar: "الكاميرون" } },
  { id: 32, name: { en: "Canada", fr: "Canada", ar: "كندا" } },
  {
    id: 33,
    name: {
      en: "Central African Republic",
      fr: "République centrafricaine",
      ar: "جمهورية أفريقيا الوسطى",
    },
  },
  { id: 34, name: { en: "Chad", fr: "Tchad", ar: "تشاد" } },
  { id: 35, name: { en: "Chile", fr: "Chili", ar: "تشيلي" } },
  { id: 36, name: { en: "China", fr: "Chine", ar: "الصين" } },
  { id: 37, name: { en: "Colombia", fr: "Colombie", ar: "كولومبيا" } },
  { id: 38, name: { en: "Comoros", fr: "Comores", ar: "جزر القمر" } },
  { id: 39, name: { en: "Congo", fr: "Congo", ar: "الكونغو" } },
  { id: 40, name: { en: "Costa Rica", fr: "Costa Rica", ar: "كوستاريكا" } },
  { id: 41, name: { en: "Croatia", fr: "Croatie", ar: "كرواتيا" } },
  { id: 42, name: { en: "Cuba", fr: "Cuba", ar: "كوبا" } },
  { id: 43, name: { en: "Cyprus", fr: "Chypre", ar: "قبرص" } },
  { id: 44, name: { en: "Czechia", fr: "Tchéquie", ar: "تشيكيا" } },
  { id: 45, name: { en: "Denmark", fr: "Danemark", ar: "الدانمارك" } },
  { id: 46, name: { en: "Djibouti", fr: "Djibouti", ar: "جيبوتي" } },
  { id: 47, name: { en: "Dominica", fr: "Dominique", ar: "دومينيكا" } },
  {
    id: 48,
    name: {
      en: "Dominican Republic",
      fr: "République dominicaine",
      ar: "الجمهورية الدومينيكية",
    },
  },
  { id: 49, name: { en: "Ecuador", fr: "Équateur", ar: "الإكوادور" } },
  { id: 50, name: { en: "Egypt", fr: "Égypte", ar: "مصر" } },
  { id: 51, name: { en: "El Salvador", fr: "Salvador", ar: "السلفادور" } },
  {
    id: 52,
    name: {
      en: "Equatorial Guinea",
      fr: "Guinée équatoriale",
      ar: "غينيا الاستوائية",
    },
  },
  { id: 53, name: { en: "Eritrea", fr: "Érythrée", ar: "إريتريا" } },
  { id: 54, name: { en: "Estonia", fr: "Estonie", ar: "إستونيا" } },
  { id: 55, name: { en: "Eswatini", fr: "Eswatini", ar: "إسواتيني" } },
  { id: 56, name: { en: "Ethiopia", fr: "Éthiopie", ar: "إثيوبيا" } },
  { id: 57, name: { en: "Fiji", fr: "Fidji", ar: "فيجي" } },
  { id: 58, name: { en: "Finland", fr: "Finlande", ar: "فنلندا" } },
  { id: 59, name: { en: "France", fr: "France", ar: "فرنسا" } },
  { id: 60, name: { en: "Gabon", fr: "Gabon", ar: "الغابون" } },
  { id: 61, name: { en: "Gambia", fr: "Gambie", ar: "غامبيا" } },
  { id: 62, name: { en: "Georgia", fr: "Géorgie", ar: "جورجيا" } },
  { id: 63, name: { en: "Germany", fr: "Allemagne", ar: "ألمانيا" } },
  { id: 64, name: { en: "Ghana", fr: "Ghana", ar: "غانا" } },
  { id: 65, name: { en: "Greece", fr: "Grèce", ar: "اليونان" } },
  { id: 66, name: { en: "Grenada", fr: "Grenade", ar: "غرينادا" } },
  { id: 67, name: { en: "Guatemala", fr: "Guatemala", ar: "غواتيمالا" } },
  { id: 68, name: { en: "Guinea", fr: "Guinée", ar: "غينيا" } },
  {
    id: 69,
    name: { en: "Guinea-Bissau", fr: "Guinée-Bissau", ar: "غينيا بيساو" },
  },
  { id: 70, name: { en: "Guyana", fr: "Guyana", ar: "غيانا" } },
  { id: 71, name: { en: "Haiti", fr: "Haïti", ar: "هايتي" } },
  { id: 72, name: { en: "Honduras", fr: "Honduras", ar: "هندوراس" } },
  { id: 73, name: { en: "Hungary", fr: "Hongrie", ar: "المجر" } },
  { id: 74, name: { en: "Iceland", fr: "Islande", ar: "آيسلندا" } },
  { id: 75, name: { en: "India", fr: "Inde", ar: "الهند" } },
  { id: 76, name: { en: "Indonesia", fr: "Indonésie", ar: "إندونيسيا" } },
  { id: 77, name: { en: "Iran", fr: "Iran", ar: "إيران" } },
  { id: 78, name: { en: "Iraq", fr: "Irak", ar: "العراق" } },
  { id: 79, name: { en: "Ireland", fr: "Irlande", ar: "أيرلندا" } },
  { id: 80, name: { en: "Israel", fr: "Israël", ar: "إسرائيل" } },
  { id: 81, name: { en: "Italy", fr: "Italie", ar: "إيطاليا" } },
  { id: 82, name: { en: "Jamaica", fr: "Jamaïque", ar: "جامايكا" } },
  { id: 83, name: { en: "Japan", fr: "Japon", ar: "اليابان" } },
  { id: 84, name: { en: "Jordan", fr: "Jordanie", ar: "الأردن" } },
  { id: 85, name: { en: "Kazakhstan", fr: "Kazakhstan", ar: "كازاخستان" } },
  { id: 86, name: { en: "Kenya", fr: "Kenya", ar: "كينيا" } },
  { id: 87, name: { en: "Kiribati", fr: "Kiribati", ar: "كيريباتي" } },
  {
    id: 88,
    name: { en: "North Korea", fr: "Corée du Nord", ar: "كوريا الشمالية" },
  },
  {
    id: 89,
    name: { en: "South Korea", fr: "Corée du Sud", ar: "كوريا الجنوبية" },
  },
  { id: 90, name: { en: "Kosovo", fr: "Kosovo", ar: "كوسوفو" } },
  { id: 91, name: { en: "Kuwait", fr: "Koweït", ar: "الكويت" } },
  { id: 92, name: { en: "Kyrgyzstan", fr: "Kirghizistan", ar: "قيرغيزستان" } },
  { id: 93, name: { en: "Laos", fr: "Laos", ar: "لاوس" } },
  { id: 94, name: { en: "Latvia", fr: "Lettonie", ar: "لاتفيا" } },
  { id: 95, name: { en: "Lebanon", fr: "Liban", ar: "لبنان" } },
  { id: 96, name: { en: "Lesotho", fr: "Lesotho", ar: "ليسوتو" } },
  { id: 97, name: { en: "Liberia", fr: "Libéria", ar: "ليبيريا" } },
  { id: 98, name: { en: "Libya", fr: "Libye", ar: "ليبيا" } },
  {
    id: 99,
    name: { en: "Liechtenstein", fr: "Liechtenstein", ar: "ليختنشتاين" },
  },
  { id: 100, name: { en: "Lithuania", fr: "Lituanie", ar: "ليتوانيا" } },
  { id: 101, name: { en: "Luxembourg", fr: "Luxembourg", ar: "لوكسمبورغ" } },
  { id: 102, name: { en: "Madagascar", fr: "Madagascar", ar: "مدغشقر" } },
  { id: 103, name: { en: "Malawi", fr: "Malawi", ar: "ملاوي" } },
  { id: 104, name: { en: "Malaysia", fr: "Malaisie", ar: "ماليزيا" } },
  { id: 105, name: { en: "Maldives", fr: "Maldives", ar: "جزر المالديف" } },
  { id: 106, name: { en: "Mali", fr: "Mali", ar: "مالي" } },
  { id: 107, name: { en: "Malta", fr: "Malte", ar: "مالطا" } },
  {
    id: 108,
    name: { en: "Marshall Islands", fr: "Îles Marshall", ar: "جزر مارشال" },
  },
  { id: 109, name: { en: "Mauritania", fr: "Mauritanie", ar: "موريتانيا" } },
  { id: 110, name: { en: "Mauritius", fr: "Maurice", ar: "موريشيوس" } },
  { id: 111, name: { en: "Mexico", fr: "Mexique", ar: "المكسيك" } },
  { id: 112, name: { en: "Micronesia", fr: "Micronésie", ar: "ميكرونيزيا" } },
  { id: 113, name: { en: "Moldova", fr: "Moldavie", ar: "مولدوفا" } },
  { id: 114, name: { en: "Monaco", fr: "Monaco", ar: "موناكو" } },
  { id: 115, name: { en: "Mongolia", fr: "Mongolie", ar: "منغوليا" } },
  { id: 116, name: { en: "Montenegro", fr: "Monténégro", ar: "الجبل الأسود" } },
  { id: 117, name: { en: "Morocco", fr: "Maroc", ar: "المغرب" } },
  { id: 118, name: { en: "Mozambique", fr: "Mozambique", ar: "موزمبيق" } },
  { id: 119, name: { en: "Myanmar", fr: "Myanmar", ar: "ميانمار" } },
  { id: 120, name: { en: "Namibia", fr: "Namibie", ar: "ناميبيا" } },
  { id: 121, name: { en: "Nauru", fr: "Nauru", ar: "ناورو" } },
  { id: 122, name: { en: "Nepal", fr: "Népal", ar: "نيبال" } },
  { id: 123, name: { en: "Netherlands", fr: "Pays-Bas", ar: "هولندا" } },
  {
    id: 124,
    name: { en: "New Zealand", fr: "Nouvelle-Zélande", ar: "نيوزيلندا" },
  },
  { id: 125, name: { en: "Nicaragua", fr: "Nicaragua", ar: "نيكاراغوا" } },
  { id: 126, name: { en: "Niger", fr: "Niger", ar: "النيجر" } },
  { id: 127, name: { en: "Nigeria", fr: "Nigeria", ar: "نيجيريا" } },
  {
    id: 128,
    name: {
      en: "North Macedonia",
      fr: "Macédoine du Nord",
      ar: "شمال مقدونيا",
    },
  },
  { id: 129, name: { en: "Norway", fr: "Norvège", ar: "النرويج" } },
  { id: 130, name: { en: "Oman", fr: "Oman", ar: "عمان" } },
  { id: 131, name: { en: "Pakistan", fr: "Pakistan", ar: "باكستان" } },
  { id: 132, name: { en: "Palau", fr: "Palaos", ar: "بالاو" } },
  { id: 133, name: { en: "Panama", fr: "Panama", ar: "بنما" } },
  {
    id: 134,
    name: {
      en: "Papua New Guinea",
      fr: "Papouasie-Nouvelle-Guinée",
      ar: "بابوا غينيا الجديدة",
    },
  },
  { id: 135, name: { en: "Paraguay", fr: "Paraguay", ar: "باراغواي" } },
  { id: 136, name: { en: "Peru", fr: "Pérou", ar: "بيرو" } },
  { id: 137, name: { en: "Philippines", fr: "Philippines", ar: "الفيلبين" } },
  { id: 138, name: { en: "Poland", fr: "Pologne", ar: "بولندا" } },
  { id: 139, name: { en: "Portugal", fr: "Portugal", ar: "البرتغال" } },
  { id: 140, name: { en: "Qatar", fr: "Qatar", ar: "قطر" } },
  { id: 141, name: { en: "Romania", fr: "Roumanie", ar: "رومانيا" } },
  { id: 142, name: { en: "Russia", fr: "Russie", ar: "روسيا" } },
  { id: 143, name: { en: "Rwanda", fr: "Rwanda", ar: "رواندا" } },
  {
    id: 144,
    name: {
      en: "Saint Kitts and Nevis",
      fr: "Saint-Christophe-et-Niévès",
      ar: "سانت كيتس ونيفيس",
    },
  },
  {
    id: 145,
    name: { en: "Saint Lucia", fr: "Sainte-Lucie", ar: "سانت لوسيا" },
  },
  {
    id: 146,
    name: {
      en: "Saint Vincent and the Grenadines",
      fr: "Saint-Vincent-et-les Grenadines",
      ar: "سانت فينسنت وجزر غرينادين",
    },
  },
  { id: 147, name: { en: "Samoa", fr: "Samoa", ar: "ساموا" } },
  { id: 148, name: { en: "San Marino", fr: "Saint-Marin", ar: "سان مارينو" } },
  {
    id: 149,
    name: {
      en: "Sao Tome and Principe",
      fr: "Sao Tomé-et-Principe",
      ar: "ساو تومي وبرينسيبي",
    },
  },
  {
    id: 150,
    name: {
      en: "Saudi Arabia",
      fr: "Arabie saoudite",
      ar: "المملكة العربية السعودية",
    },
  },
  { id: 151, name: { en: "Senegal", fr: "Sénégal", ar: "السنغال" } },
  { id: 152, name: { en: "Serbia", fr: "Serbie", ar: "صربيا" } },
  { id: 153, name: { en: "Seychelles", fr: "Seychelles", ar: "سيشل" } },
  { id: 154, name: { en: "Sierra Leone", fr: "Sierra Leone", ar: "سيراليون" } },
  { id: 155, name: { en: "Singapore", fr: "Singapour", ar: "سنغافورة" } },
  { id: 156, name: { en: "Slovakia", fr: "Slovaquie", ar: "سلوفاكيا" } },
  { id: 157, name: { en: "Slovenia", fr: "Slovénie", ar: "سلوفينيا" } },
  {
    id: 158,
    name: { en: "Solomon Islands", fr: "Îles Salomon", ar: "جزر سليمان" },
  },
  { id: 159, name: { en: "Somalia", fr: "Somalie", ar: "الصومال" } },
  {
    id: 160,
    name: { en: "South Africa", fr: "Afrique du Sud", ar: "جنوب أفريقيا" },
  },
  {
    id: 161,
    name: { en: "South Sudan", fr: "Soudan du Sud", ar: "جنوب السودان" },
  },
  { id: 162, name: { en: "Spain", fr: "Espagne", ar: "إسبانيا" } },
  { id: 163, name: { en: "Sri Lanka", fr: "Sri Lanka", ar: "سريلانكا" } },
  { id: 164, name: { en: "Sudan", fr: "Soudan", ar: "السودان" } },
  { id: 165, name: { en: "Suriname", fr: "Suriname", ar: "سورينام" } },
  { id: 166, name: { en: "Sweden", fr: "Suède", ar: "السويد" } },
  { id: 167, name: { en: "Switzerland", fr: "Suisse", ar: "سويسرا" } },
  { id: 168, name: { en: "Syria", fr: "Syrie", ar: "سوريا" } },
  { id: 169, name: { en: "Taiwan", fr: "Taïwan", ar: "تايوان" } },
  { id: 170, name: { en: "Tajikistan", fr: "Tadjikistan", ar: "طاجيكستان" } },
  { id: 171, name: { en: "Tanzania", fr: "Tanzanie", ar: "تنزانيا" } },
  { id: 172, name: { en: "Thailand", fr: "Thaïlande", ar: "تايلاند" } },
  {
    id: 173,
    name: { en: "Timor-Leste", fr: "Timor oriental", ar: "تيمور الشرقية" },
  },
  { id: 174, name: { en: "Togo", fr: "Togo", ar: "توغو" } },
  { id: 175, name: { en: "Tonga", fr: "Tonga", ar: "تونغا" } },
  {
    id: 176,
    name: {
      en: "Trinidad and Tobago",
      fr: "Trinité-et-Tobago",
      ar: "ترينيداد وتوباغو",
    },
  },
  { id: 177, name: { en: "Tunisia", fr: "Tunisie", ar: "تونس" } },
  { id: 178, name: { en: "Turkey", fr: "Turquie", ar: "تركيا" } },
  {
    id: 179,
    name: { en: "Turkmenistan", fr: "Turkménistan", ar: "تركمانستان" },
  },
  { id: 180, name: { en: "Tuvalu", fr: "Tuvalu", ar: "توفالو" } },
  { id: 181, name: { en: "Uganda", fr: "Ouganda", ar: "أوغندا" } },
  { id: 182, name: { en: "Ukraine", fr: "Ukraine", ar: "أوكرانيا" } },
  {
    id: 183,
    name: {
      en: "United Arab Emirates",
      fr: "Émirats arabes unis",
      ar: "الإمارات العربية المتحدة",
    },
  },
  {
    id: 184,
    name: { en: "United Kingdom", fr: "Royaume-Uni", ar: "المملكة المتحدة" },
  },
  {
    id: 185,
    name: { en: "United States", fr: "États-Unis", ar: "الولايات المتحدة" },
  },
  { id: 186, name: { en: "Uruguay", fr: "Uruguay", ar: "أورغواي" } },
  { id: 187, name: { en: "Uzbekistan", fr: "Ouzbékistan", ar: "أوزبكستان" } },
  { id: 188, name: { en: "Vanuatu", fr: "Vanuatu", ar: "فانواتو" } },
  {
    id: 189,
    name: { en: "Vatican City", fr: "Cité du Vatican", ar: "الفاتيكان" },
  },
  { id: 190, name: { en: "Venezuela", fr: "Venezuela", ar: "فنزويلا" } },
  { id: 191, name: { en: "Vietnam", fr: "Viêt Nam", ar: "فيتنام" } },
  { id: 192, name: { en: "Yemen", fr: "Yémen", ar: "اليمن" } },
  { id: 193, name: { en: "Zambia", fr: "Zambie", ar: "زامبيا" } },
  { id: 194, name: { en: "Zimbabwe", fr: "Zimbabwe", ar: "زيمبابوي" } },
];

export let CURRENCIES = [
  { id: "USD", name: "USD" },
  { id: "DZD", name: "DZD" },
  { id: "TND", name: "TND" },
  { id: "SAR", name: "SAR" },
  { id: "CNY", name: "CNY" },
  { id: "GBP", name: "GBP" },
  { id: "JPY", name: "JPY" },
  { id: "AUD", name: "AUD" },
  { id: "CAD", name: "CAD" },
  { id: "CHF", name: "CHF" },
  { id: "SEK", name: "SEK" },
  { id: "NZD", name: "NZD" },
  { id: "MXN", name: "MXN" },
  { id: "SGD", name: "SGD" },
  { id: "HKD", name: "HKD" },
  { id: "NOK", name: "NOK" },
  { id: "KRW", name: "KRW" },
  { id: "TRY", name: "TRY" },
  { id: "INR", name: "INR" },
  { id: "BRL", name: "BRL" },
  { id: "RUB", name: "RUB" },
  { id: "ZAR", name: "ZAR" },
  { id: "QAR", name: "QAR" },
  { id: "KWD", name: "KWD" },
  { id: "OMR", name: "OMR" },
  { id: "BHD", name: "BHD" },
];

export let COLORS = [
  { id: 1, name: { fr: "Rouge", en: "Red", ar: "أحمر" }, code: "#FF0000" },
  { id: 2, name: { fr: "Vert", en: "Green", ar: "أخضر" }, code: "#00FF00" },
  { id: 3, name: { fr: "Bleu", en: "Blue", ar: "أزرق" }, code: "#0000FF" },
  { id: 4, name: { fr: "Jaune", en: "Yellow", ar: "أصفر" }, code: "#FFFF00" },
  {
    id: 5,
    name: { fr: "Violet", en: "Purple", ar: "أرجواني" },
    code: "#800080",
  },
  {
    id: 6,
    name: { fr: "Orange", en: "Orange", ar: "برتقالي" },
    code: "#FFA500",
  },
  { id: 7, name: { fr: "Rose", en: "Pink", ar: "وردي" }, code: "#FFC0CB" },
  { id: 8, name: { fr: "Marron", en: "Brown", ar: "بني" }, code: "#A52A2A" },
  { id: 9, name: { fr: "Gris", en: "Gray", ar: "رمادي" }, code: "#808080" },
  { id: 10, name: { fr: "Noir", en: "Black", ar: "أسود" }, code: "#000000" },
  { id: 11, name: { fr: "Blanc", en: "White", ar: "أبيض" }, code: "#FFFFFF" },
  {
    id: 12,
    name: { fr: "Turquoise", en: "Turquoise", ar: "تركواز" },
    code: "#40E0D0",
  },
  {
    id: 13,
    name: { fr: "Citron vert", en: "Lime", ar: "ليمون" },
    code: "#00FF00",
  },
  {
    id: 14,
    name: { fr: "Bleu ciel", en: "Sky Blue", ar: "سماء زرقاء" },
    code: "#87CEEB",
  },
  {
    id: 15,
    name: { fr: "Sarcelle", en: "Teal", ar: "سماء زرقاء" },
    code: "#008080",
  },
  { id: 16, name: { fr: "Olive", en: "Olive", ar: "زيتوني" }, code: "#808000" },
  {
    id: 17,
    name: { fr: "Bordeaux", en: "Burgundy", ar: "برغندي" },
    code: "#800020",
  },
  {
    id: 18,
    name: { fr: "Bleu marine", en: "Navy Blue", ar: "أزرق داكن" },
    code: "#000080",
  },
  {
    id: 19,
    name: { fr: "Magenta", en: "Magenta", ar: "قرمزي" },
    code: "#FF00FF",
  },
  {
    id: 20,
    name: { fr: "Saumon", en: "Salmon", ar: "سالمون" },
    code: "#FA8072",
  },
  {
    id: 21,
    name: { fr: "Lavande", en: "Lavender", ar: "لافندر" },
    code: "#E6E6FA",
  },
  { id: 22, name: { fr: "Kaki", en: "Khaki", ar: "كاكي" }, code: "#C3B091" },
  { id: 23, name: { fr: "Sable", en: "Tan", ar: "رملي" }, code: "#F4A460" },
  {
    id: 24,
    name: { fr: "Bleu royal", en: "Royal Blue", ar: "أزرق ملكي" },
    code: "#4169E1",
  },
  { id: 25, name: { fr: "Indigo", en: "Indigo", ar: "نيلي" }, code: "#4B0082" },
  { id: 26, name: { fr: "Or", en: "Gold", ar: "ذهبي" }, code: "#FFD700" },
  { id: 27, name: { fr: "Argent", en: "Silver", ar: "فضي" }, code: "#C0C0C0" },
  {
    id: 28,
    name: { fr: "Bronze", en: "Bronze", ar: "برونزي" },
    code: "#CD7F32",
  },
  { id: 29, name: { fr: "Pêche", en: "Peach", ar: "خوخي" }, code: "#FFDAB9" },
  {
    id: 30,
    name: { fr: "Framboise", en: "Raspberry", ar: "توت أحمر" },
    code: "#C71585",
  },
  {
    id: 31,
    name: { fr: "Grenat", en: "Maroon", ar: "قرمزي داكن" },
    code: "#800000",
  },
  {
    id: 32,
    name: { fr: "Aubergine", en: "Eggplant", ar: "باذنجاني" },
    code: "#6E2C00",
  },
  {
    id: 33,
    name: { fr: "Citron", en: "Lemon", ar: "ليموني" },
    code: "#FFFACD",
  },
  {
    id: 34,
    name: { fr: "Corail", en: "Coral", ar: "مرجاني" },
    code: "#FF7F50",
  },
  {
    id: 35,
    name: { fr: "Chocolat", en: "Chocolate", ar: "شوكولاتة" },
    code: "#D2691E",
  },
  {
    id: 36,
    name: { fr: "Charbon", en: "Charcoal", ar: "فحم" },
    code: "#36454F",
  },
  { id: 37, name: { fr: "Cyan", en: "Cyan", ar: "سيان" }, code: "#00FFFF" },
  {
    id: 38,
    name: { fr: "Émeraude", en: "Emerald", ar: "زمردي" },
    code: "#50C878",
  },
  { id: 39, name: { fr: "Ivoire", en: "Ivory", ar: "عاجي" }, code: "#FFFFF0" },
  {
    id: 40,
    name: { fr: "Moutarde", en: "Mustard", ar: "خردل" },
    code: "#FFDB58",
  },
  { id: 41, name: { fr: "Mauve", en: "Mauve", ar: "موف" }, code: "#E0B0FF" },
  { id: 42, name: { fr: "Perle", en: "Pearl", ar: "لؤلؤ" }, code: "#F0F0F0" },
  {
    id: 43,
    name: { fr: "Safran", en: "Saffron", ar: "زعفران" },
    code: "#FFD933",
  },
  {
    id: 44,
    name: { fr: "Taupe", en: "Taupe", ar: "رمادي داكن" },
    code: "#483C32",
  },
  {
    id: 45,
    name: { fr: "Bleu poudre", en: "Powder Blue", ar: "أزرق فاتح" },
    code: "#B0E0E6",
  },
  { id: 46, name: { fr: "Cerise", en: "Cherry", ar: "كرزي" }, code: "#DE3163" },
  {
    id: 47,
    name: { fr: "Orchidée", en: "Orchid", ar: "أوركيد" },
    code: "#DA70D6",
  },
  {
    id: 48,
    name: { fr: "Azur", en: "Azure", ar: "أزرق سماوي" },
    code: "#007FFF",
  },
  {
    id: 49,
    name: { fr: "Vanille", en: "Vanilla", ar: "فانيليا" },
    code: "#F3E5AB",
  },
  {
    id: 50,
    name: { fr: "Framboise", en: "Raspberry", ar: "توت أحمر" },
    code: "#C71585",
  },
];

export const FAQ = [
  {
    question: {
      en: "Do you provide product sourcing?",
      fr: "Fournissez-vous la recherche de produits ?",
      ar: "هل نقدم خدمة البحث عن المنتجات؟",
    },
    response: {
      en: "We do not offer product sourcing, we only provide air transport for goods that have arrived at our warehouse in China.",
      fr: "Nous n'offrons pas de service de recherche de produits, nous proposons uniquement le transport aérien des marchandises arrivées dans notre entrepôt en Chine.",
      ar: "نحن ال نقدم خدمة البحث عن المنتجات. نحن نقدم فقط خدمات الشحن الجوي للبضائع التي تصل إلى مستودعنا في الصين",
    },
  },
  {
    question: {
      en: "Do you provide shipment of goods by sea?",
      fr: "Proposez-vous l'expédition de marchandises par mer ?",
      ar: "هل نقدم شحن البضائع عن طريق البحر؟",
    },
    response: {
      en: "We do not provide shipment by sea.",
      fr: "Nous n’offrons pas le transport maritime.",
      ar: "ال، نحن ال نقدم خدمة الشحن عن طريق البحر",
    },
  },
  {
    question: {
      en: "What is the delivery time?",
      fr: "Quels sont les délais de livraison?",
      ar: "ما هي مدة التسليم؟",
    },
    response: {
      en: "The delivery times range from 15 to 25 days for air transport from China, and from 7 to 15 days for air transport from the UAE.",
      fr: "Les délais de livraison varient entre 15 et 25 jours pour le transport aérien depuis la Chine, et de 7 à 15 jours pour le transport aérien depuis les Émirats arabes unis.",
      ar: "تتراوح مدة التسليم من 15 إلى 25 يو ًما للشحن الجوي من الصين، ومن 7 إلى 15 يو ًما للشحن الجوي من اإلمارات العربية المتحدة",
    },
  },
  {
    question: {
      en: "Do you have a warehouse in China?",
      fr: "Avez-vous un entrepôt en Chine ?",
      ar: "هل لديكم مستودع في الصين؟",
    },
    response: {
      en: "Yes, we have two warehouses in China. Please specify with us via private message the details of your products so that we can send you the appropriate address.",
      fr: "Oui, nous avons deux entrepôts en Chine. Veuillez nous fournir les détails de vos produits par message privé afin que nous puissions vous envoyer l'adresse appropriée.",
      ar: "نعم، لدينا مستودعين في الصين. يرجى تحديد التفاصيل الخاصة بمنتجاتكم معنا عبر الرسالة الخاصة حتى نتمكن من إرسال العنوان المناسب لكم",
    },
  },
  {
    question: {
      en: "Do you have an office in Algeria?",
      fr: "Disposez-vous d'un bureau en Algérie ?",
      ar: "هل لديكم مكتب في الجزائر؟",
    },
    response: {
      en: "Yes, we are located at 93 street Didouche Mourad, Sidi M’hammed.",
      fr: "Oui, nous nous trouvons au 93 rue Didouche Mourad, Sidi M’hammed",
      ar: "نعم، نحن موجودون في شارع ديدوش مراد رقم 93 سيدي إمحمد.",
    },
  },
  {
    question: {
      en: "When do I pay the fees for air transport?",
      fr: "Quand est-ce que l'on paie les frais de transport aérien ?",
      ar: "متى أقوم بدفع رسوم النقل الجوي؟",
    },
    response: {
      en: "You pay the air transport fees upon receipt of your merchandise.",
      fr: "Vous payez les frais du transport aérien lors de la réception de votre marchandise.",
      ar: "تقوم بدفع رسوم النقل الجوي عند استالم البضائع الخاصة بك",
    },
  },
  {
    question: {
      en: "Do you offer assistance for people who wish to travel to China to purchase goods?",
      fr: "Proposez-vous un accompagnement pour les personnes qui souhaitent se déplacer en Chine pour l'achat de marchandises ?",
      ar: "هل تقدمون مساعدة لألشخاص الذين يرغبون في السفر إلى الصين لشراء البضائع؟",
    },
    response: {
      en: "Yes, we offer an accompanying service. Please contact us via private message so that we can provide you with the contact information of our agent in China and explain all the details to you.",
      fr: "Oui, nous proposons le service d’accompagnement, contactez nous via message privé afin de vous transmettre le contact de notre agent en chine et vous expliquer tous les détails.",
      ar: "نعم، نحن نقدم خدمة مرافقة. يرجى التواصل معنا عبر الرسالة الخاصة حتى نتمكن من تزويدك بمعلومات االتصال بوكيلنا في الصين وشرح جميع التفاصيل لك.",
    },
  },
  {
    question: {
      en: "Do you offer sample quality verification?",
      fr: "Proposez-vous une vérification de la qualité des échantillons ?",
      ar: "هل تقدمون خدمة التحقق من جودة العينات؟",
    },
    response: {
      en: "Yes, we offer a verification service for samples sent to a specified address. Please contact us via private message to receive the details.",
      fr: "Oui, nous proposons une vérification pour les échantillons envoyés à une adresse spécifiée, contactez-nous via message privé pour vous envoyer les détails.",
      ar: "نعم، نحن نقدم خدمة التحقق من جودة العينات التي يتم إرسالها إلى عنوان محدد. يرجى التواصل معنا عبر الرسالة الخاصة لتلقي التفاصيل.",
    },
  },
  {
    question: {
      en: "How and where can I find a supplier?",
      fr: "Comment et où puis-je trouver un fournisseur ?",
      ar: "كيف وأين يمكنني العثور على مورد؟",
    },
    response: {
      en: "You can find suppliers on the Alibaba platform or on other Chinese platforms that offer wholesale for various products.",
      fr: "Vous pouvez trouver des fournisseurs sur la plateforme Alibaba ou sur d'autres plateformes chinoises qui proposent la vente en gros pour divers produits.",
      ar: "يمكنك العثور على الموردين على منصة ALIBABA أو على منصات صينية أخرى تقدم بيع بالجملة لمجموعة متنوعة من المنتجات.",
    },
  },
  {
    question: {
      en: "What are the products that you do not import?",
      fr: "Quels sont les produits que vous n'importez pas?",
      ar: "ما هي المنتجات التي ال نستوردها؟",
    },
    response: {
      en: "We do not import bulky and heavy products (exceeding 1kg), medicines and dietary supplements, agri-food products, smartphones, tablets, laptops, industrial machinery, white powder products, liquid products, medical equipment, gold and silver, cameras.",
      fr: "Nous n'importons pas les produits volumineux et lourds (dépassant 1 kg), les médicaments et compléments alimentaires, les produits agroalimentaires, les smartphones, les tablettes, les ordinateurs portables, les machines industrielles, les produits en poudre blanche, les produits liquides, le matériel médical, l'or et l'argent, les caméras.",
      ar: "نحن ال نستورد المنتجات الضخمة والثقيلة )تزيد عن 1 كغ(، واألدوية والمكمالت الغذائية، والمنتجات الزراعية الغذائية، والهواتف الذكية، واألجهزة اللوحية، وأجهزة الكمبيوتر المحمولة، واآلالت الصناعية، والمنتجات البيضاء بشكل مسحوق، والمنتجات السائلة، والمعدات الطبية، والذهب والفضة، والكاميرات",
    },
  },
  {
    question: {
      en: "Do you have insurance for the transported merchandise?",
      fr: "Avez-vous une assurance pour la marchandise transportée ?",
      ar: "هل لديكم تأمين للبضائع المنقولة؟",
    },
    response: {
      en: "Yes, we have insurance for the merchandise included in the price given for air transportation.",
      fr: "Oui, nous avons une assurance pour la marchandise incluse dans le prix donné pour le transport aérien.",
      ar: "نعم، لدينا تأمين للبضائع مضمن في السعر المحدد للنقل الجوي",
    },
  },
  {
    question: {
      en: "What is the minimum weight for air transport?",
      fr: "Quel est le poids minimum pour le transport aérien ?",
      ar: "ما هو الحد األدنى للوزن للنقل الجوي؟",
    },
    response: {
      en: "The minimum weight is 5kg per carton.",
      fr: "Le poids minimum est de 5 kg par carton.",
      ar: "الحد األدنى هو 5 كيلوجرام لكل صندوق",
    },
  },
  {
    question: {
      en: "What is the maximum weight for air transport?",
      fr: "Quel est le poids maximum pour le transport aérien ?",
      ar: "ما هو الحد األقصى للوزن للنقل الجوي؟",
    },
    response: {
      en: "We do not have a maximum weight, you can choose whatever suits you.",
      fr: "Nous n’avons pas un poids maximal, vous pouvez choisir ce qui vous convient.",
      ar: "ليس لدينا حد أقصى للوزن، يمكنك اختيار ما يناسبك",
    },
  },
  {
    question: {
      en: "How to place an order?",
      fr: "Comment passer commande?",
      ar: "كيفية تقديم الطلب؟",
    },
    response: {
      en: "You select a product from the catalog presented on the platform, enter the desired quantity, and then insert the payment receipt. This way, your order is validated.",
      fr: "Vous choisissez un produit du catalogue présenté sur la plateforme, vous rentrez la quantité voulue puis vous insérez le reçu de versement et comme ça votre commande est validée.",
      ar: "تختار المنتج من الكتالوج المعروض على المنصة، ثم تدخل الكمية المطلوبة وتضع إيصال الدفع، وبهذا تتم موافقة طلبك.",
    },
  },
  {
    question: {
      en: "How to request a quotation for air shipping from China?",
      fr: "Comment demander un devis pour un transport aérien depuis la Chine?",
      ar: "كيفية طلب عرض أسعار الشحن من الصين؟",
    },
    response: {
      en: "You click on 'Request a quote', then you fill out the form carefully and validate it. A confirmation email will be sent to you.",
      fr: "Vous cliquez sur demander un devis, vous remplissez le formulaire attentivement et vous validez . Un e-mail de confirmation vous sera envoyé.",
      ar: "يمكنك النقر على 'طلب عرض سعر من الصين'، ثم ملء االستمارة بعناية وتأكيد الطلب. سيتم إرسال بريد إلكتروني تأكيدي إليك.",
    },
  },
];

export const wilayas = [
  { id: 1, name: { en: "Adrar", fr: "Adrar", ar: "أدرار" } },
  { id: 2, name: { en: "Chlef", fr: "Chlef", ar: "الشلف" } },
  { id: 3, name: { en: "Laghouat", fr: "Laghouat", ar: "الأغواط" } },
  {
    id: 4,
    name: { en: "Oum El Bouaghi", fr: "Oum El Bouaghi", ar: "أم البواقي" },
  },
  { id: 5, name: { en: "Batna", fr: "Batna", ar: "باتنة" } },
  { id: 6, name: { en: "Béjaïa", fr: "Béjaïa", ar: "بجاية" } },
  { id: 7, name: { en: "Biskra", fr: "Biskra", ar: "بسكرة" } },
  { id: 8, name: { en: "Béchar", fr: "Béchar", ar: "بشار" } },
  { id: 9, name: { en: "Blida", fr: "Blida", ar: "البليدة" } },
  { id: 10, name: { en: "Bouira", fr: "Bouira", ar: "البويرة" } },
  { id: 11, name: { en: "Tamanrasset", fr: "Tamanrasset", ar: "تمنراست" } },
  { id: 12, name: { en: "Tébessa", fr: "Tébessa", ar: "تبسة" } },
  { id: 13, name: { en: "Tlemcen", fr: "Tlemcen", ar: "تلمسان" } },
  { id: 14, name: { en: "Tiaret", fr: "Tiaret", ar: "تيارت" } },
  { id: 15, name: { en: "Tizi Ouzou", fr: "Tizi Ouzou", ar: "تيزي وزو" } },
  { id: 16, name: { en: "Algiers", fr: "Alger", ar: "الجزائر" } },
  { id: 17, name: { en: "Djelfa", fr: "Djelfa", ar: "الجلفة" } },
  { id: 18, name: { en: "Jijel", fr: "Jijel", ar: "جيجل" } },
  { id: 19, name: { en: "Sétif", fr: "Sétif", ar: "سطيف" } },
  { id: 20, name: { en: "Saïda", fr: "Saïda", ar: "سعيدة" } },
  { id: 21, name: { en: "Skikda", fr: "Skikda", ar: "سكيكدة" } },
  {
    id: 22,
    name: { en: "Sidi Bel Abbès", fr: "Sidi Bel Abbès", ar: "سيدي بلعباس" },
  },
  { id: 23, name: { en: "Annaba", fr: "Annaba", ar: "عنابة" } },
  { id: 24, name: { en: "Guelma", fr: "Guelma", ar: "قالمة" } },
  { id: 25, name: { en: "Constantine", fr: "Constantine", ar: "قسنطينة" } },
  { id: 26, name: { en: "Médéa", fr: "Médéa", ar: "المدية" } },
  { id: 27, name: { en: "Mostaganem", fr: "Mostaganem", ar: "مستغانم" } },
  { id: 28, name: { en: "MSila", fr: "M'Sila", ar: "المسيلة" } },
  { id: 29, name: { en: "Mascara", fr: "Mascara", ar: "معسكر" } },
  { id: 30, name: { en: "Ouargla", fr: "Ouargla", ar: "ورقلة" } },
  { id: 31, name: { en: "Oran", fr: "Oran", ar: "وهران" } },
  { id: 32, name: { en: "El Bayadh", fr: "El Bayadh", ar: "البيض" } },
  { id: 33, name: { en: "Illizi", fr: "Illizi", ar: "إليزي" } },
  {
    id: 34,
    name: {
      en: "Bordj Bou Arreridj",
      fr: "Bordj Bou Arreridj",
      ar: "برج بوعريريج",
    },
  },
  { id: 35, name: { en: "Boumerdès", fr: "Boumerdès", ar: "بومرداس" } },
  { id: 36, name: { en: "El Tarf", fr: "El Tarf", ar: "الطارف" } },
  { id: 37, name: { en: "Tindouf", fr: "Tindouf", ar: "تندوف" } },
  { id: 38, name: { en: "Tissemsilt", fr: "Tissemsilt", ar: "تيسمسيلت" } },
  { id: 39, name: { en: "El Oued", fr: "El Oued", ar: "الوادي" } },
  { id: 40, name: { en: "Khenchela", fr: "Khenchela", ar: "خنشلة" } },
  { id: 41, name: { en: "Souk Ahras", fr: "Souk Ahras", ar: "سوق أهراس" } },
  { id: 42, name: { en: "Tipaza", fr: "Tipaza", ar: "تيبازة" } },
  { id: 43, name: { en: "Mila", fr: "Mila", ar: "ميلة" } },
  { id: 44, name: { en: "Aïn Defla", fr: "Aïn Defla", ar: "عين الدفلى" } },
  { id: 45, name: { en: "Naâma", fr: "Naâma", ar: "النعامة" } },
  {
    id: 46,
    name: { en: "Aïn Témouchent", fr: "Aïn Témouchent", ar: "عين تموشنت" },
  },
  { id: 47, name: { en: "Ghardaïa", fr: "Ghardaïa", ar: "غرداية" } },
  { id: 48, name: { en: "Relizane", fr: "Relizane", ar: "غليزان" } },
  { id: 49, name: { en: "Timimoun", fr: "Timimoun", ar: "تيميمون" } },
  {
    id: 50,
    name: {
      en: "Bordj Badji Mokhtar",
      fr: "Bordj Badji Mokhtar",
      ar: "برج باجي مختار",
    },
  },
  {
    id: 51,
    name: { en: "Ouled Djellal", fr: "Ouled Djellal", ar: "أولاد جلال" },
  },
  { id: 52, name: { en: "Béni Abbès", fr: "Béni Abbès", ar: "بني عباس" } },
  { id: 53, name: { en: "In Salah", fr: "In Salah", ar: "عين صالح" } },
  { id: 54, name: { en: "In Guezzam", fr: "In Guezzam", ar: "عين قزّام" } },
  { id: 55, name: { en: "Touggourt", fr: "Touggourt", ar: "تقرت" } },
  { id: 56, name: { en: "Djanet", fr: "Djanet", ar: "جانت" } },
  { id: 57, name: { en: "El M'Ghair", fr: "El M'Ghair", ar: "المغير" } },
  { id: 58, name: { en: "El Menia", fr: "El Menia", ar: "المنيعة" } },
];


export const fuelTypes = [
  { id: 1, name: { en: "Petrol", fr: "Essence", ar: "بنزين" } },
  { id: 2, name: { en: "Electric", fr: "Électrique", ar: "كهرباء" } },
  { id: 4, name: { en: "Hybrid", fr: "Hybride", ar: "هجين" } },
];


export const transmissionTypes = [
  { id: 1, name: { en: "Manual", fr: "Manuelle", ar: "يدوي" } },
  { id: 2, name: { en: "Automatic", fr: "Automatique", ar: "أوتوماتيكي" } },
  { id: 3, name: { en: "Semi-Automatic", fr: "Semi-automatique", ar: "شبه أوتوماتيكي" } },
  { id: 4, name: { en: "CVT (Continuously Variable Transmission)", fr: "Boîte CVT (Transmission à variation continue)", ar: "ناقل حركة متغير باستمرار (CVT)" } },
  { id: 5, name: { en: "Automated Manual Transmission (AMT)", fr: "Boîte robotisée", ar: "ناقل حركة يدوي آلي" } },
  { id: 6, name: { en: "Dual-Clutch Transmission (DCT)", fr: "Boîte à double embrayage", ar: "ناقل حركة مزدوج القابض" } },
  { id: 7, name: { en: "Sequential Transmission", fr: "Transmission séquentielle", ar: "ناقل حركة تسلسلي" } },
  { id: 8, name: { en: "Electronic CVT (e-CVT)", fr: "Boîte e-CVT", ar: "ناقل حركة CVT إلكتروني" } }
];


import { 
  FaCarCrash, FaSnowflake, FaBell, FaCarSide,  FaCaravan, FaSun, FaBorderAll, 
  FaUserShield, FaChair, FaMapMarkedAlt, FaParking, FaTachometerAlt, FaBluetooth, 
  FaCamera, FaThermometerFull, FaKey, FaPowerOff, FaCloudversify, FaLightbulb, 
  FaLightbulb as FaXenon, FaLightbulb as FaLed, FaTemperatureHigh, 
  FaRegCompass, FaRoad, FaEye, FaShieldAlt, FaBatteryFull, FaMobileAlt, FaTv, FaBaby, 
  FaSatelliteDish, FaTachometerAlt as FaAdaptive, FaParking as FaFrontParking, 
  FaKey as FaRemoteKey, FaApple, FaFan, FaCouch 
} from 'react-icons/fa';
import { GiCarSeat } from 'react-icons/gi';

export const CarFeatures = [
  { id: 8, name: { en: "ABS", fr: "ABS", ar: "نظام فرامل مانع للانغلاق" }, icon: FaCarCrash },
  { id: 9, name: { en: "Air Conditioning", fr: "Climatisation", ar: "مكيف هواء" }, icon: FaSnowflake },
  // { id: 10, name: { en: "Alarm", fr: "Alarme", ar: "جهاز إنذار" }, icon: FaBell },
  { id: 11, name: { en: "Alloy Wheels", fr: "Jantes alliage", ar: "عجلات ألمنيوم" }, icon: FaCarSide },
  { id: 12, name: { en: "Electric Mirrors", fr: "Rétroviseurs électriques", ar: "مرايا كهربائية" }, icon: FaLightbulb },
  { id: 13, name: { en: "ADAS System", fr: "Système ADAS", ar: "نظام مساعدة السائق (ADAS)" }, icon: FaCaravan },
  { id: 14, name: { en: "Sunroof", fr: "Toit ouvrant", ar: "سقف متحرك" }, icon: FaSun },
  { id: 15, name: { en: "Panoramic Roof", fr: "Toit panoramique", ar: "سقف بانورامي" }, icon: FaBorderAll },
  { id: 16, name: { en: "Driver and passenger airbags", fr: "Airbags conducteur et passager", ar: "وسائد هوائية للسائق والراكب" }, icon: FaUserShield },
  { id: 17, name: { en: "Leather Seats", fr: "Sièges en cuir", ar: "مقاعد جلدية" }, icon: FaChair },
  { id: 18, name: { en: "Navigation System", fr: "Système de navigation", ar: "نظام ملاحة" }, icon: FaMapMarkedAlt },
  { id: 19, name: { en: "Parking Sensors", fr: "Capteurs de stationnement", ar: "حساسات ركن السيارة" }, icon: FaParking },
  { id: 20, name: { en: "Cruise Control", fr: "Régulateur de vitesse", ar: "نظام تثبيت السرعة" }, icon: FaTachometerAlt },
  { id: 21, name: { en: "Bluetooth", fr: "Bluetooth", ar: "بلوتوث" }, icon: FaBluetooth },
  { id: 22, name: { en: "Rearview Camera", fr: "Caméra de recul", ar: "كاميرا خلفية" }, icon: FaCamera },
  { id: 23, name: { en: "Heated Seats", fr: "Sièges chauffants", ar: "مقاعد مدفأة" }, icon: FaThermometerFull },
  { id: 24, name: { en: "Keyless Entry", fr: "Accès sans clé", ar: "دخول بدون مفتاح" }, icon: FaKey },
  { id: 25, name: { en: "Remote Start", fr: "Démarrage à distance", ar: "تشغيل عن بعد" }, icon: FaPowerOff },
  { id: 26, name: { en: "Fog Lights", fr: "Phares antibrouillard", ar: "أضواء ضباب" }, icon: FaCloudversify },
  { id: 27, name: { en: "Xenon Headlights", fr: "Phares au xénon", ar: "مصابيح زينون" }, icon: FaXenon },
  { id: 28, name: { en: "LED Headlights", fr: "Phares LED", ar: "مصابيح LED" }, icon: FaLed },
  { id: 29, name: { en: "Electric Seats", fr: "Sièges électriques", ar: "مقاعد كهربائية" }, icon: GiCarSeat },
  { id: 30, name: { en: "Automatic Climate Control", fr: "Climatisation automatique", ar: "تحكم آلي بالمناخ" }, icon: FaTemperatureHigh },
  { id: 31, name: { en: "Adaptive Cruise Control", fr: "Régulateur de vitesse adaptatif", ar: "مثبت سرعة متكيف" }, icon: FaRegCompass },
  { id: 32, name: { en: "Lane Assist", fr: "Aide au maintien de voie", ar: "مساعد الحفاظ على المسار" }, icon: FaRoad },
  { id: 33, name: { en: "Blind Spot Monitor", fr: "Surveillance des angles morts", ar: "مراقبة النقطة العمياء" }, icon: FaEye },
  { id: 34, name: { en: "Automatic Emergency Braking", fr: "Freinage automatique d'urgence", ar: "الفرملة التلقائية في حالات الطوارئ" }, icon: FaShieldAlt },
  { id: 35, name: { en: "Wireless Charger", fr: "Chargeur sans fil", ar: "شاحن لاسلكي" }, icon: FaBatteryFull },
  { id: 36, name: { en: "Android Auto / Apple CarPlay", fr: "Android Auto / Apple CarPlay", ar: "أندرويد أوتو / أبل كار بلاي" }, icon: FaMobileAlt },
  { id: 37, name: { en: "Digital Dashboard", fr: "Tableau de bord numérique", ar: "لوحة عدادات رقمية" }, icon: FaTv },
  { id: 38, name: { en: "Isofix Child Seat Interface", fr: "Interface siège enfant Isofix", ar: "واجهة مقعد أطفال Isofix" }, icon: FaBaby },
  { id: 39, name: { en: "Rear Parking Radar", fr: "Radar de stationnement arrière", ar: "رادار خلفي لركن السيارة" }, icon: FaSatelliteDish },
  { id: 40, name: { en: "Full Speed Adaptive Cruise Control", fr: "Régulateur de vitesse adaptatif toutes vitesses", ar: "مثبت سرعة متكيف بكامل السرعة" }, icon: FaAdaptive },
  { id: 41, name: { en: "Front Parking Sensors", fr: "Capteurs de stationnement avant", ar: "حساسات ركن أمامية" }, icon: FaFrontParking },
  { id: 42, name: { en: "Remote Key", fr: "Clé à distance", ar: "مفتاح عن بعد" }, icon: FaRemoteKey },
  { id: 43, name: { en: "Support CarPlay", fr: "Compatibilité CarPlay", ar: "دعم CarPlay" }, icon: FaApple },
  { id: 44, name: { en: "Automatic Air Conditioning", fr: "Climatisation automatique", ar: "مكيف هواء أوتوماتيكي" }, icon: FaFan },
  { id: 45, name: { en: "Faux Leather Seat", fr: "Siège en simili cuir", ar: "مقاعد من الجلد الصناعي" }, icon: FaCouch },
];


export const CarFeaturess= CarFeatures.map((car)=>{ return {id : car?.name?.en , name : car?.name , icon  : car?.icon}})

export const CarOrdersStatuses = [
  {
    id: 1,
    name: { en: "Pending", fr: "En attente", ar: "قيد الانتظار" },
    color: "#5A5A5AFF",            // orange
    secondaryColor: "#DFDFDFFF",   // light orange
  },
  {
    id: 2,
    name: { en: "Document Verification", fr: "Vérification des documents", ar: "مراجعة الوثائق" },
    color: "#29B6F6",            // blue
    secondaryColor: "#B3E5FC",   // light blue
  },
  {
    id: 3,
    name: { en: "Awaiting Payment", fr: "En attente de paiement", ar: "في انتظار الدفع" },
    color: "#FF7043",            // deep orange
    secondaryColor: "#FFCCBC8B",   // light deep orange
  },
  {
    id: 5,
    name: { en: "Car Registration In Progress", fr: "Immatriculation en cours", ar: "تسجيل السيارة قيد التنفيذ" },
    color: "#AB47BC",            // purple
    secondaryColor: "#E1BEE7",   // light purple
  },
  {
    id: 6,
    name: {
      en: "Import & Tracking",
      fr: "Suivi de l'import",
      ar: "تتبع الاستيراد"
    },
    color: "#38888E",            // dark teal
    secondaryColor: "#A5C7D6",   // light teal
  },
  {
    id: 7,
    name: { en: "Completed", fr: "Terminée", ar: "مكتملة" },
    color: "#388E3C",            // dark green
    secondaryColor: "#A5D6A7",   // light dark green
  },
  {
    id: 8,
    name: { en: "Cancelled", fr: "Annulée", ar: "ملغاة" },
    color: "#EF5350",            // red
    secondaryColor: "#FFCDD2",   // light red
  },
];
